import React, { useEffect, useState } from "react";
import { Checkbox, TextInput, Button } from "@mantine/core";
import { getQuestions, saveQuestions } from "../misc/api";

export const AdminQuestionSystem = () => {
  const [questions, setQuestions] = useState();
  const [allExpanded, setAllExpanded] = useState(false);
  const [expandedRules, setExpandedRules] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getQuestions().then((x) => {
      const transformedQuestions = x?.data.map((question) => {
        const options = question.options;

        const questionText = question.question_text;
        const bilingualQuestionText = JSON.parse(questionText);

        // Transform options to support bilingual format
        const bilingualOptions = options.map((option) => {
          if (option.title_lv && option.title_en) {
            // Already in bilingual format
            return option;
          } else if (option.title) {
            // Convert from old format
            return {
              title_lv: option.title,
              title_en: "",
              right: option.right,
            };
          } else {
            // New empty option
            return {
              title_lv: "",
              title_en: "",
              right: false,
            };
          }
        });

        return {
          ...question,
          questionText: bilingualQuestionText,
          options: bilingualOptions,
        };
      });
      setQuestions(transformedQuestions);

      const initialExpandedState = {};
      transformedQuestions.forEach((question, index) => {
        initialExpandedState[index] = false;
      });
      setExpandedRules(initialExpandedState);
      setLoading(false);
    });
  }, []);

  const saveQuestionFn = () => {
    saveQuestions(questions);
    window.location.reload();
  };

  const handleQuestionChange = (index, language, newValue) => {
    const newQuestions = [...questions];
    newQuestions[index].questionText = {
      ...newQuestions[index].questionText,
      [language]: newValue,
    };
    setQuestions(newQuestions);
  };

  const handleOptionChange = (
    questionIndex,
    optionIndex,
    language,
    newValue
  ) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options[optionIndex] = {
      ...newQuestions[questionIndex].options[optionIndex],
      [`title_${language}`]: newValue,
    };
    setQuestions(newQuestions);
  };

  const markQuestionAsRight = (questionIndex, optionIndex, newValue) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options[optionIndex] = {
      ...newQuestions[questionIndex].options[optionIndex],
      right: newValue,
    };
    setQuestions(newQuestions);
  };

  const addQuestion = () => {
    setQuestions([
      ...questions,
      {
        questionText: { lv: "", en: "" },
        options: [{ title_lv: "", title_en: "", right: false }],
      },
    ]);
  };

  const addOption = (questionIndex) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options.push({
      title_lv: "",
      title_en: "",
      right: false,
    });
    setQuestions(newQuestions);
  };

  const removeOption = (questionIndex, optionIndex) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options.splice(optionIndex, 1);
    setQuestions(newQuestions);
  };

  const toggleAllExpansion = () => {
    setAllExpanded((prev) => !prev);
    const newExpandedState = {};
    questions.forEach((_, index) => {
      newExpandedState[index] = !allExpanded;
    });
    setExpandedRules(newExpandedState);
  };

  const toggleQuestionExpansion = (index) => {
    setExpandedRules((prevExpanded) => ({
      ...prevExpanded,
      [index]: !prevExpanded[index],
    }));
  };

  const removeQuestion = (index) => {
    const newQuestions = [...questions];
    const questionToRemove = newQuestions[index];

    if (questionToRemove.id) {
      newQuestions[index] = { ...questionToRemove, deleted: true };
    } else {
      newQuestions.splice(index, 1);
    }
    setQuestions(newQuestions);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          zIndex: 20,
          backgroundColor: "white",
          justifyContent: "space-between",
          position: "fixed",
          padding: 10,
          width: "-webkit-fill-available",
          marginLeft: -20,
          marginTop: -20,
        }}
      >
        <h2>Questions (LV/EN)</h2>
        <Button
          onClick={() => toggleAllExpansion()}
          style={{ marginTop: 10, marginLeft: 10 }}
        >
          {allExpanded ? "Hide All" : "Expand All"}
        </Button>
      </div>
      <div style={{ paddingTop: 80 }}>
        {questions?.map(
          (question, questionIndex) =>
            question.deleted != true && (
              <div
                key={questionIndex}
                style={{
                  padding: 15,
                  backgroundColor: "#f1f1f1",
                  borderRadius: 10,
                  marginBottom: 10,
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    marginBottom: 10,
                    textDecoration: "underline",
                  }}
                  onClick={() => toggleQuestionExpansion(questionIndex)}
                >
                  {expandedRules[questionIndex] ? "Hide" : "Show"} Question:{" "}
                  {question.questionText?.lv ||
                    question.questionText?.en ||
                    "New Question"}
                </div>
                {expandedRules[questionIndex] && (
                  <>
                    <div></div>
                    <TextInput
                      label="Jautājums (LV)"
                      value={question.questionText?.lv || ""}
                      onChange={(event) =>
                        handleQuestionChange(
                          questionIndex,
                          "lv",
                          event.currentTarget.value
                        )
                      }
                      style={{ marginBottom: 10 }}
                    />

                    {/* English Question Input */}
                    <TextInput
                      label="Question (EN)"
                      value={question.questionText?.en || ""}
                      onChange={(event) =>
                        handleQuestionChange(
                          questionIndex,
                          "en",
                          event.currentTarget.value
                        )
                      }
                      style={{ marginBottom: 10 }}
                    />

                    <div style={{ display: "flex", paddingTop: 10 }}>
                      <small style={{ fontSize: 12 }}>Pareizais?</small>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        paddingTop: 10,
                      }}
                    >
                      {question.options.map((option, optionIndex) => (
                        <div
                          key={optionIndex}
                          className="options"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 10,
                            padding: 10,
                            backgroundColor: "white",
                            borderRadius: 5,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: 10,
                            }}
                          >
                            <Checkbox
                              checked={option.right}
                              size="xl"
                              onChange={(event) =>
                                markQuestionAsRight(
                                  questionIndex,
                                  optionIndex,
                                  !option.right
                                )
                              }
                            />
                            <Button
                              onClick={() =>
                                removeOption(questionIndex, optionIndex)
                              }
                              style={{
                                marginLeft: "auto",
                                color: "white",
                                backgroundColor: "red",
                                minWidth: 30,
                                height: 30,
                              }}
                              compact
                            >
                              X
                            </Button>
                          </div>

                          {/* Latvian Option Input */}
                          <TextInput
                            placeholder="Atbilde (LV)"
                            value={option.title_lv || ""}
                            style={{ width: "100%", marginBottom: 5 }}
                            onChange={(event) =>
                              handleOptionChange(
                                questionIndex,
                                optionIndex,
                                "lv",
                                event.currentTarget.value
                              )
                            }
                          />

                          {/* English Option Input */}
                          <TextInput
                            placeholder="Answer (EN)"
                            value={option.title_en || ""}
                            style={{ width: "100%" }}
                            onChange={(event) =>
                              handleOptionChange(
                                questionIndex,
                                optionIndex,
                                "en",
                                event.currentTarget.value
                              )
                            }
                          />
                        </div>
                      ))}
                      <Button
                        onClick={() => addOption(questionIndex)}
                        style={{ marginLeft: 10, width: 50, fontSize: 20 }}
                      >
                        +
                      </Button>
                      <Button
                        onClick={() => removeQuestion(questionIndex)}
                        style={{
                          marginTop: 10,
                          backgroundColor: "red",
                          color: "white",
                        }}
                        variant="link"
                      >
                        Remove
                      </Button>
                    </div>
                  </>
                )}
              </div>
            )
        )}
      </div>
      <Button onClick={addQuestion} style={{ marginTop: 10 }}>
        Pievienot jautājumu
      </Button>
      <hr></hr>
      <div>
        <Button
          onClick={() => saveQuestionFn()}
          disabled={loading}
          style={{ marginTop: 10, paddingLeft: 50, paddingRight: 50 }}
        >
          Save
        </Button>
      </div>
    </>
  );
};
